(function () {
  'use strict';

  angular.module('sempraWebapp').factory('messageActions', messageActionsFactory);

  /** @ngInject */
  function messageActionsFactory ($q, api, dispatcher, ActionTypesEnum, $translate) {
    return {
      getAllMessages: getAllMessages,
      getAlarmMessages: getAlarmMessages,
      dismissAlarm: dismissAlarm,
      getKarcherAlarms: getKarcherAlarms,
      getKarcherAlarmSubscriptions: getKarcherAlarmSubscriptions,
      createAlarmSubscription: createAlarmSubscription,
      unsubscribeKarcherAlert: unsubscribeKarcherAlert
    };

    function getAlarmMessages () {
      var deferred = $q.defer();

      api.getAlarmMessages().then(function (data) {
        deferred.resolve(data);
        dispatcher.dispatch({
          type: ActionTypesEnum.GET_ALARM_MESSAGES,
          payload: data
        });
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getAllMessages (deviceKey, fromTimeStamp, toTimestamp, page, pageSize, orderBy, order) {
      var deferred = $q.defer();

      api.getMessages(deviceKey, fromTimeStamp, toTimestamp, page, pageSize, orderBy, order).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function dismissAlarm (alarmId) {
      var deferred = $q.defer();

      api.dismissAlarm(alarmId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getKarcherAlarms () {
      var deferred = $q.defer();

      api.getKarcherAlarms().then(function(response) {
        deferred.resolve(response);
        dispatcher.dispatch({
          type: ActionTypesEnum.GET_ALARM_KARCHER_MESSAGES,
          payload: response
        });
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getKarcherAlarmSubscriptions() {
      var deferred = $q.defer();

      api.getKarcherAlarmSubscriptions().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function createAlarmSubscription(data) {
      var deferred = $q.defer();

      api.createAlarmSubscription(data).then(function (data) {
        deferred.resolve(data);
        // dispatch message
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message: $translate.instant('ALARM_SUBSCRIBED')
          }
        });
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function unsubscribeKarcherAlert(siteId) {
      var deferred = $q.defer();

      api.unsubscribeKarcherAlert(siteId).then(function (data) {
        deferred.resolve(data);
        // dispatch message
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message: $translate.instant('ALARM_UNSUBSCRIBED')
          }
        });
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();
